import type { IntakeFormField, IntakeFormSection } from '../../api/bookingApi';

// Retained draft answers count only when their controller is itself visible.
// An unanswered checkbox is distinct from an explicit false answer.
export function isFieldVisible(
  field: IntakeFormField,
  values: Record<string, unknown>,
  sections: IntakeFormSection[],
): boolean {
  const visiting = new Set<string>();
  const visible = (current: IntakeFormField): boolean => {
    if (!current.show_if) return true;
    if (visiting.has(current.key)) return false;
    visiting.add(current.key);
    const condition = current.show_if;
    const controller = sections.flatMap((section) => section.fields).find((candidate) => candidate.key === condition.field);
    const actual = values[condition.field];
    const result = !!controller && visible(controller)
      && (typeof actual === 'string' || typeof actual === 'boolean') && actual === condition.equals;
    visiting.delete(current.key);
    return result;
  };
  return visible(field);
}
